const BACKEND_API_TYPE_FIELD_PATH = 'backendApiType';

export { BACKEND_API_TYPE_FIELD_PATH };
